//csgo商品种类
const classification = [{
    value: 0,
    label: '不限'
  },
  {
    value: 1,
    label: '匕首',
    children: [{
        value: 1,
        label: '匕首(不限)',
      },
      {
        value: '1-1',
        label: '折叠刀',
      },
      {
        value: '1-2',
        label: '刺刀',
      },
      {
        value: '1-3',
        label: '弯刀',
      },
      {
        value: '1-4',
        label: '鲍伊猎刀',
      },
      {
        value: '1-5',
        label: '锯齿爪刀',
      },
      {
        value: '1-6',
        label: '熊刀',
      },
      {
        value: '1-7',
        label: '穿肠刀',
      },
      {
        value: '1-8',
        label: 'M9 刺刀',
      },
      {
        value: '1-9',
        label: '蝴蝶刀',
      },
      {
        value: '1-10',
        label: '暗影双匕',
      },
      {
        value: '1-11',
        label: '猎杀者匕首',
      },
      {
        value: '1-12',
        label: '短剑',
      },
      {
        value: '1-13',
        label: '折刀',
      },
      {
        value: '1-14',
        label: '求生匕首',
      },
      {
        value: '1-15',
        label: '骷髅匕首',
      },
      {
        value: '1-16',
        label: '系绳匕首',
      },
      {
        value: '1-17',
        label: '流浪者匕首',
      },
      {
        value: '1-18',
        label: '海豹短刀',
      },
			{
				value: '1-19',
				label: '爪子刀',
			}
    ]
  },
  {
    value: 2,
    label: '手枪',
    children: [{
        value: 2,
        label: '手枪(不限)',
      },
      {
        value: '2-1',
        label: 'P2000',
      },
      {
        value: '2-2',
        label: '格洛克 18 型',
      },
      {
        value: '2-3',
        label: 'FN57',
      },
      {
        value: '2-4',
        label: 'Tec-9',
      },
      {
        value: '2-5',
        label: '双持贝瑞塔',
      },
      {
        value: '2-6',
        label: 'USP 消音版',
      },
      {
        value: '2-7',
        label: 'P250',
      },
      {
        value: '2-8',
        label: 'CZ75 自动手枪',
      },
      {
        value: '2-9',
        label: 'R8 左轮手枪',
      },
      {
        value: '2-10',
        label: '沙漠之鹰',
      },
    ]
},

{
    value: 3,
    label: '步枪',
    children: [{
        value: 3,
        label: '步枪(不限)',
      },
      {
        value: '3-1',
        label: '法玛斯',
      },
      {
        value: '3-2',
        label: 'M4A4',
      },
      {
        value: '3-3',
        label: 'AK-47',
      },
      {
        value: '3-4',
        label: 'SG 553',
      },
      {
        value: '3-5',
        label: 'SCAR-20',
      },
      {
        value: '3-6',
        label: 'G3SG1',
      },
      {
        value: '3-7',
        label: '加利尔 AR',
      },
      {
        value: '3-8',
        label: 'M4A1 消音型',
      },
      {
        value: '3-9',
        label: 'AUG',
      },
      {
        value: '3-10',
        label: 'SSG 08',
      },
      {
        value: '3-11',
        label: 'AWP',
      },
    ]
},

{
    value: 4,
    label: '微型冲锋枪',
    children: [{
        value: 4,
        label: '微型冲锋枪(不限)',
      },
      {
        value: '4-1',
        label: 'MAC-10',
      },
      {
        value: '4-2',
        label: 'MP7',
      },
      {
        value: '4-3',
        label: 'PP-野牛',
      },
      {
        value: '4-4',
        label: 'MP5-SD',
      },
      {
        value: '4-5',
        label: 'MP9',
      },
      {
        value: '4-6',
        label: 'UMP-45',
      },
      {
        value: '4-7',
        label: 'P90',
      },
    ]
},

{
    value: 5,
    label: '重型武器',
    children: [{
        value: 5,
        label: '重型武器(不限)',
      },
      {
        value: '5-1',
        label: '新星',
      },
      {
        value: '5-2',
        label: 'MAG-7',
      },
      {
        value: '5-3',
        label: 'XM1014',
      },
      {
        value: '5-4',
        label: '截短霰弹枪',
      },
      {
        value: '5-5',
        label: 'M249',
      },
      {
        value: '5-6',
        label: '内格夫',
      },
    ]
},

{
    value: 6,
    label: '手套',
    children: [{
        value: 6,
        label: '手套(不限)',
      },
      {
        value: '6-1',
        label: '血猎手套',
      },
      {
        value: '6-2',
        label: '裹手',
      },
      {
        value: '6-3',
        label: '专业手套',
      },
      {
        value: '6-4',
        label: '驾驶手套',
      },
      {
        value: '6-5',
        label: '摩托手套',
      },
      {
        value: '6-6',
        label: '运动手套',
      },
      {
        value: '6-7',
        label: '九头蛇手套',
      },
    ]
},

{
    value:  7,
    label: '印花'
},

{
    value: 8,
    label: '其它',
    children: [{
        value: 8,
        label: '其它(不限)',
      },
      {
        value: '8-1',
        label: '布章',
      },
      {
        value: '8-2',
        label: '探员',
      },
      {
        value: '8-3',
        label: '武器箱',
      },
      {
        value: '8-4',
        label: '涂鸦',
      },
      {
        value: '8-5',
        label: '音乐盒',
      },
      {
        value: '8-6',
        label: '收藏品/胸章',
      },
      {
        value: '8-7',
        label: '通行证',
      },
      {
        value: '8-8',
        label: '礼物',
      },
      {
        value: '8-9',
        label: '标签',
      },
      {
        value: '8-10',
        label: '工具',
      },
    ]
},
]


export default  classification
